interface FinancialAgreementState {
  opened: boolean;
  showDocument: boolean;
  documentText: string | null;
}

const FINANCIAL_AGREEMENT_SET_OPENED = "FINANCIAL_AGREEMENT_SET_OPENED";
const FINANCIAL_AGREEMENT_SET_SHOW_DOCUMENT =
  "FINANCIAL_AGREEMENT_SET_SHOW_DOCUMENT";
const FINANCIAL_AGREEMENT_SET_DOCUMENT_TEXT =
  "FINANCIAL_AGREEMENT_SET_DOCUMENT_TEXT";
const FINANCIAL_AGREEMENT_RESET = "FINANCIAL_AGREEMENT_RESET";

interface SetOpenedAction {
  type: typeof FINANCIAL_AGREEMENT_SET_OPENED;
  payload: boolean;
}

interface SetShowDocumentAction {
  type: typeof FINANCIAL_AGREEMENT_SET_SHOW_DOCUMENT;
  payload: boolean;
}

interface SetDocumentTextAction {
  type: typeof FINANCIAL_AGREEMENT_SET_DOCUMENT_TEXT;
  payload: string | null;
}

interface ResetAction {
  type: typeof FINANCIAL_AGREEMENT_RESET;
}

type FinancialAgreementAction =
  | SetOpenedAction
  | SetShowDocumentAction
  | SetDocumentTextAction
  | ResetAction;

const initialState: FinancialAgreementState = {
  opened: false,
  showDocument: false,
  documentText: null,
};

export const financialAgreementReducer = (
  state: FinancialAgreementState = initialState,
  action: FinancialAgreementAction
): FinancialAgreementState => {
  switch (action.type) {
    case FINANCIAL_AGREEMENT_SET_OPENED: {
      const opened = action.payload;
      return {
        ...state,
        opened,
      };
    }
    case FINANCIAL_AGREEMENT_SET_SHOW_DOCUMENT: {
      const showDocument = action.payload;
      return {
        ...state,
        showDocument,
      };
    }
    case FINANCIAL_AGREEMENT_SET_DOCUMENT_TEXT: {
      const documentText = action.payload;
      return {
        ...state,
        documentText,
      };
    }
    case FINANCIAL_AGREEMENT_RESET: {
      return { ...initialState };
    }
    default:
      return state;
  }
};
